<ng-template #trustedcontactOperationModal>
    <div class="page-modal-section">
        <div class="page-modal-heading-section">
            <span>{{ operation_type }} Trusted Contact Details</span>
            <span class="page-modal-close-icon" (click)="closeTrustedContactOperationModal()" >&times;</span>
        </div>
        <div class="page-modal-content-section">
            <div class="page-modal-input-section">
            <p class="page-modal-input-label">First Name *</p>
                <input
                    type="text"
                    class="page-modal-input"
                    [(ngModel)]="trustedcontact_data.first_name"
                />
                <p class="page-modal-input-error" *ngIf="trustedcontact_data_errors.first_name">First Name is Required.</p>
            </div>

            <div class="page-modal-input-section">
                <p class="page-modal-input-label">Last Name *</p>
                <input
                    type="text"
                    class="page-modal-input"
                    [(ngModel)]="trustedcontact_data.last_name"
                />
                <p class="page-modal-input-error" *ngIf="trustedcontact_data_errors.last_name">Last Name is Required.</p>
            </div>

            <div class="page-modal-input-section">
                <p class="page-modal-input-label">Email</p>
                <input
                    type="text"
                    class="page-modal-input"
                    [(ngModel)]="trustedcontact_data.email"
                />
                <p class="page-modal-input-error" *ngIf="trustedcontact_data_errors.email">Email must be valid.</p>
            </div>

            <div class="page-modal-input-section">
                <p class="page-modal-input-label">Phone Number * {{APP_CONSTANTS.PHONE_NUMBER_FORMAT}}</p>
                <input
                    type="text"
                    class="page-modal-input"
                    [(ngModel)]="trustedcontact_data.telephone_number"
                    maxlength="{{APP_CONSTANTS.PHONE_NUMBER_LENGTH}}"
                    appFormatPhoneNumber
                />
                <p class="page-modal-input-error" *ngIf="trustedcontact_data_errors.telephone_number">Phone Number must be in valid format.</p>
            </div>

            <div class="page-modal-input-section">
                <p class="page-modal-input-label">Date of Birth</p>
                <input
                    type="text"
                    class="page-modal-input"
                    bsDatepicker
                    [maxDate]="current_date"
                    [(ngModel)]="trustedcontact_data.birth_date"
                    [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
                    placement="left"
                />
                <p class="page-modal-input-error" *ngIf="trustedcontact_data_errors.birth_date">Date of Birth is Required.</p>
            </div>

            <div class="page-modal-input-section">
                <p class="page-modal-input-label">Gender</p>
                <mat-select class="page-modal-input" [(ngModel)]="trustedcontact_data.gender">
                    <mat-option [value]="''">Select Gender</mat-option>
                    <mat-option *ngFor="let gender of genders_list" [value]="gender.id" (click)="trustedcontact_data.gender_name = gender.name">{{gender.name}}</mat-option>
                </mat-select>
                <p class="page-modal-input-error" *ngIf="trustedcontact_data_errors.gender">Gender is Required.</p>
            </div>

            <div class="page-modal-input-section">
                <p class="page-modal-input-label">Relationship</p>
                <mat-select class="page-modal-input" [(ngModel)]="trustedcontact_data.relationship_type">
                    <mat-option [value]="''">Select Relationship</mat-option>
                    <mat-option *ngFor="let relationship of relationships_list" [value]="relationship.id" (click)="trustedcontact_data.relationship_type_name = relationship.name">{{relationship.name}}</mat-option>
                </mat-select>
                <p class="page-modal-input-error" *ngIf="trustedcontact_data_errors.relationship_type">Relationship is Required.</p>
            </div>

        </div>
        <div class="page-modal-footer-section">
            <button class="page-modal-primary-button" (click)="saveTrustedContactData()">Save</button>
            <button class="page-modal-secondary-button" (click)="closeTrustedContactOperationModal()">Cancel</button>
        </div>
    </div>
</ng-template>


<ng-template #trustedcontactDeleteModal>
	<div class="page-modal-section">
		<div class="page-modal-heading-section">
			<span>Delete Trusted Contact Details</span>
			<span class="page-modal-close-icon" (click)="closeTrustedContactDeleteModal()">&times;</span>
		</div>
		<div class="page-modal-content-section">
			<p class="page-modal-delete-description">Are you sure you want to delete?</p>
		</div>
		<div class="page-modal-footer-section">
			<button class="page-modal-primary-button" (click)="deleteTrustedContactData()">Yes</button>
			<button class="page-modal-secondary-button" (click)="closeTrustedContactDeleteModal()">No</button>
	    </div>
    </div>
</ng-template>
